import { makeAutoObservable } from "mobx";
import construct from "../utils/construct";
import persist from "../utils/persist";

// eslint-disable-next-line
let _rootStore;

/**
 * @typedef {Object} NavbarState
 * @property {number} width
 * @property {boolean} opened
 */

/**
 * @typedef {Object} ThumbBurgerState
 * @property {boolean} show
 * @property {"left" | "right"} position
 */

const defaultProperties = {
	language: "es-ES",
	theme: "dark",
	header: {
		height: 70,
	},
	navbar: {
		width: 0,
		opened: true,
	},
	thumbBurger: {
		show: true,
		position: /** @type {"left" | "right"} */ ("left"),
	},
};

export default class UiStore {
	/** @type {string} */
	language = defaultProperties.language;
	/** @type {string} */
	theme = defaultProperties.theme;
	/** @type {{ height: number }} */
	header = defaultProperties.header;
	/** @type {NavbarState} */
	navbar = defaultProperties.navbar;
	/** @type {ThumbBurgerState} */
	thumbBurger = defaultProperties.thumbBurger;

	constructor(rootStore) {
		construct(this, defaultProperties);
		_rootStore = rootStore;

		makeAutoObservable(this);
		persist(this, "uiStore");
	}

	reset() {
		construct(this, defaultProperties);
	}

	/** * @param {"light" | "dark"} theme */
	toggleTheme = (theme) => {
		// Forzamos tema
		if (theme) {
			if (!["light", "dark"].includes(theme)) {
				return console.warn(`[setTheme] ${theme} is not a valid theme`);
			}

			this.theme = theme;

			// Cambiamos de un tema al otro
		} else {
			if (this.theme === "light") {
				this.theme = "dark";
			} else {
				this.theme = "light";
			}
		}
	};

	/**
	 * Devuelve si estamos en tema oscuro o no.
	 * @returns {boolean} true si estamos en tema oscuro, false si no.
	 */
	isDarkTheme = () => this.theme === "dark";

	getMobileNavbarState = () => this.navbar.opened;

	getIsNavbarOpened = () => this.navbar.opened;

	toggleMobileNavbar = () => {
		const nextState = !this.navbar.opened;
		this.navbar.opened = nextState;
		// this.navbar.open = nextState;
	};
	closeMobileNavbar = () => {
		this.navbar.opened = false;
	};
	openMobileNavbar = () => {
		this.navbar.opened = true;
	};

	getDesktopNavbarState = () => this.navbar.opened;

	toggleDesktopNavbar = () => {
		this.navbar.opened = !this.navbar.opened;
	};

	closeNavbar = () => {
		this.navbar.opened = false;
	};
	openNavbar = () => {
		this.navbar.opened = true;
	};
	toggleNavbar = () => {
		const nextState = !this.navbar.opened;
		this.navbar.opened = nextState;
	};

	/**
	 * @param {"left" | "right"} position
	 */
	setThumbBurgerPosition = (position) => {
		this.thumbBurger.position = position;
	};

	toggleThumbBurgerPosition = () => {
		if (this.thumbBurger.position === "left") {
			this.setThumbBurgerPosition("right");
		} else {
			this.setThumbBurgerPosition("left");
		}
	};
}
